import getIsFavoriteSelectorDefinition from './get-is-favorite.js'

export default [getIsFavoriteSelectorDefinition]
